/* ==========================================================================
   SP-LOGO-PREVIEW — Logo-Vorschau auf dem Produktfoto (sections/sp-logo-preview.liquid)
   Hängt sich an die Section sp-pdp-neu (assets/sp-pdp-neu.js) über drei Haken:
     el.spnState            – Zustand (Farben, Logos inkl. Datei, Position, Breite)
     Event 'spn:change'     – nach jeder Änderung
     el.spnExtraProps(s)    – zusätzliche Line-Item-Properties (Verschiebung)
     el.spnPreviewFiles(s)  – Promise mit dem Vorschaubild für den Warenkorb
   Maßstab: Brustbreite des Textils (cm) ↔ im Foto erkannte Rumpfbreite (px).
   ========================================================================== */
(function () {
  'use strict';

  var GROUND = '#EEEEEE', INK = '#111111', MUTED = '#5E656B', MINT = '#78E6D0';
  var FONT = '"Trade Gothic Shirtplus", "Arial Narrow", sans-serif';
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';

  /* Positionen relativ zu Orientierungspunkten im Foto (nicht in festen cm ab Oberkante, weil Packshots
     perspektivisch unterschiedlich gestaucht sind):
       fx = Mitte des Logos, Anteil der Rumpfbreite von der Mittellinie (> 0 = in der Ansicht rechts;
            „Brust links“ sitzt vom Betrachter aus rechts)
       fy = Oberkante des Logos, Anteil der Strecke Schulter → Achsel
       area = größte Druckfläche in cm (mittig um die Standardlage), min = frühester Beginn der Druckfläche
            (gleiche Einheit wie fy, hält sie unter dem Kragen). Werte lassen sich in der Section überschreiben.
       w  = Standardbreite in cm, ph = Seitenverhältnis Platzhalter (Höhe/Breite) */
  var POS = {
    links:    { label: 'Brust links',     side: 'front', fx: 0.22,  fy: 0.42, min: 0.28, area: [12, 12], w: 8,  ph: 1 },
    rechts:   { label: 'Brust rechts',    side: 'front', fx: -0.22, fy: 0.42, min: 0.28, area: [12, 12], w: 8,  ph: 1 },
    mitte:    { label: 'Brust Mitte',     side: 'front', fx: 0,     fy: 0.45, min: 0.28, area: [28, 28], w: 20, ph: 0.6 },
    schulter: { label: 'Schulterblatt',   side: 'back',  fx: 0,     fy: 0.20, min: 0.08, area: [30, 15], w: 25, ph: 0.35 },
    ruecken:  { label: 'Rücken komplett', side: 'back',  fx: 0,     fy: 0.36, min: 0.12, area: [30, 40], w: 28, ph: 1 }
  };
  // Orientierungspunkte als Anteil der Bildhöhe/-breite: Schulter-Oberkante, Achsel, Mitte, Rumpfbreite
  var calib = null; // Kalibrierung je Produkt (Metafeld custom.logo_vorschau), siehe init()
  var DEF_DET = { top: 0.1, ap: 0.4, cx: 0.5, tw: 0.46, conf: 'low' };
  var lastGood = {};

  /* SP-AERMEL (2026-10-09): „Ärmel links“ / „Ärmel rechts“ (Aris-Positionen, Schlüssel a-aermel-*) auf dem Vorderfoto.
     Lage und Drehung misst sleeveGeo() je Packshot aus der Kontur des in der Ansicht rechten Ärmels:
       Kurzarm: Gerade durch den Ärmelsaum (Unterkante von der inneren Saumecke bis zum Ärmelende) = Drehung, Feld und
                Logo liegen parallel dazu; Feldmitte 7,5 cm über dem Saum, Richtung Ärmelrückseite verschoben.
       Langarm (Titel „Long Sleeve“/„Langarm“): Oberarm, 22 % der Shirtlänge unter der Oberkante, 6 cm innen.
     „Ärmel links“ (Trägerseite) liegt in der Ansicht rechts, „Ärmel rechts“ ist daran an der Rumpfmitte gespiegelt.
     Nur für Produktarten aus der Section-Einstellung „Ärmel-Vorschau für Produktarten“ (Standard: T-Shirts).
     Korrektur je Produkt im Metafeld custom.logo_vorschau: { "front": { "sleeve": { "x": 0.78, "y": 0.27, "rot": -30 } } }
     (x/y = Logomitte als Anteil von Bildbreite/-höhe, rechter Ärmel in der Ansicht; rot = Drehung in Grad). */
  var SLEEVES = false, LONG = false, CHEST = 50, ZOOM = 2;
  function sleeveGeo(im, long, chestCm) {
    var nw = im.naturalWidth, nh = im.naturalHeight;
    if (!nw || !nh) return null;
    var W = 300, H = Math.max(8, Math.round(300 * nh / nw));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bg = [0, 0, 0], n = 0, i, j, k;
    [[0, 0], [W - 3, 0], [0, H - 3], [W - 3, H - 3]].forEach(function (p) {
      for (var a = 0; a < 3; a++) for (var b = 0; b < 3; b++) {
        var q = ((p[1] + b) * W + p[0] + a) * 4;
        bg[0] += d[q]; bg[1] += d[q + 1]; bg[2] += d[q + 2]; n++;
      }
    });
    bg = bg.map(function (v) { return v / n; });
    var M = new Uint8Array(W * H);
    for (k = 0; k < W * H; k++) M[k] = (Math.abs(d[k * 4] - bg[0]) + Math.abs(d[k * 4 + 1] - bg[1]) + Math.abs(d[k * 4 + 2] - bg[2]) > 42) ? 1 : 0;
    function on(px, py) { px = Math.round(px); py = Math.round(py); return px >= 0 && py >= 0 && px < W && py < H && M[py * W + px] === 1; }
    var L = [], R = [], Wd = [], top = -1, bot = -1;
    for (j = 0; j < H; j++) {
      var l = -1, r = -1;
      for (i = 0; i < W; i++) if (M[j * W + i]) { if (l < 0) l = i; r = i; }
      L.push(l); R.push(r); Wd.push(l < 0 ? 0 : r - l);
      if (l >= 0 && r - l > 4) { if (top < 0) top = j; bot = j; }
    }
    if (top < 0 || (bot - top) / H < 0.4) return null;
    function med(a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
    var hh = bot - top, mxw = 0, mr = top, ap = -1;
    for (j = top; j < top + hh * 0.6; j++) if (Wd[j] > mxw) { mxw = Wd[j]; mr = j; }
    for (j = mr; j < bot; j++) if (Wd[j] < 0.72 * mxw) { ap = j; break; }
    if (!(ap > top && (ap - top) / hh < 0.55)) { ap = -1; for (j = mr; j < bot; j++) if (Wd[j] < 0.86 * mxw) { ap = j; break; } }
    var ws = [], cs = [], rs = [], ppc, mid, cx0, cy0, phi;
    if (!long && ap > top) {
      for (j = ap + 3; j < Math.min(bot, ap + 15); j++) { ws.push(Wd[j]); cs.push((L[j] + R[j]) / 2); rs.push(R[j]); }
      if (!ws.length) return null;
      var tw = med(ws), te = med(rs); mid = med(cs); ppc = tw / chestCm;
      var cuff = Math.max.apply(null, R.slice(top, ap + 1)), bp = [];
      // je Spalte zwischen Rumpfkante und Ärmelende: Unterkante des Ärmels (erst Achsel, dann Saum)
      for (i = Math.round(te) + 1; i <= cuff; i++) {
        var j0 = -1;
        for (j = top; j < bot; j++) if (M[j * W + i]) { j0 = j; break; }
        if (j0 < 0) continue;
        var j1 = j0;
        while (j1 + 1 < H && M[(j1 + 1) * W + i]) j1++;
        bp.push([i, j1]);
      }
      if (bp.length < 6) return null;
      var am = 0;
      bp.forEach(function (p, q) { if (p[1] > bp[am][1]) am = q; });
      // Saum = Unterkante ab der inneren Saumecke (tiefster Punkt) bis kurz vor die Rundung am Ärmelende
      var hem = bp.slice(am + 1, bp.length - Math.max(1, Math.round(bp.length * 0.08)));
      if (hem.length < 4) return null;
      var mx = 0, my = 0, sxx = 0, sxy = 0;
      hem.forEach(function (p) { mx += p[0]; my += p[1]; }); mx /= hem.length; my /= hem.length;
      hem.forEach(function (p) { sxx += (p[0] - mx) * (p[0] - mx); sxy += (p[0] - mx) * (p[1] - my); });
      var slope = sxx ? sxy / sxx : 0, ha = Math.atan(slope);
      phi = ha + Math.PI / 2; // Drehung des Logos = Winkel des Saums
      var tx = Math.cos(ha), ty = Math.sin(ha), nx = Math.sin(ha), ny = -Math.cos(ha); // t entlang Saum nach außen, n vom Saum zur Schulter
      var x1 = bp[am][0], y1 = bp[am][1], x2 = hem[hem.length - 1][0], y2 = my + slope * (x2 - mx);
      var hl = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
      // Feldmitte 7,5 cm über dem Saum, Richtung Ärmelrückseite verschoben (Außenkante ca. 1 cm vor dem Ärmelende)
      var out = Math.min(hl / 2 - 6 * ppc, 3 * ppc), up = 7.5 * ppc;
      cx0 = (x1 + x2) / 2 + tx * out + nx * up; cy0 = (y1 + y2) / 2 + ty * out + ny * up;
    } else {
      // SP-AERMEL-SWEAT (12.10.2026): Bezug ist die Schulterlinie (erste Zeile mit ≥ 80 % der größten Breite),
      // nicht die Oberkante – bei Hoodies liegt die Kapuze darüber
      var sh = top;
      for (j = top; j < mr; j++) if (Wd[j] >= 0.8 * mxw) { sh = j; break; }
      var hs = bot - sh;
      for (j = Math.round(sh + 0.45 * hs); j < Math.round(sh + 0.55 * hs); j++) { ws.push(Wd[j] / 1.5); cs.push((L[j] + R[j]) / 2); }
      if (!ws.length) return null;
      ppc = med(ws) / chestCm; mid = med(cs);
      var y0 = Math.round(sh + 0.04 * hs), y1 = Math.round(sh + 0.30 * hs), mi = 0, mj = 0, syy = 0, sxy2 = 0, m = 0;
      for (j = y0; j < y1; j++) { mi += R[j]; mj += j; m++; }
      mi /= m; mj /= m;
      for (j = y0; j < y1; j++) { syy += (j - mj) * (j - mj); sxy2 += (R[j] - mi) * (j - mj); }
      var dxdy = syy ? sxy2 / syy : 0;
      phi = Math.atan2(1, dxdy);
      var nx2 = -Math.sin(phi), ny2 = Math.cos(phi), jy = sh + 0.15 * hs, qx2 = mi + dxdy * (jy - mj), s1 = 0;
      while (s1 < 10 && !on(qx2 + nx2 * s1, jy + ny2 * s1)) s1++;
      cx0 = qx2 + nx2 * (s1 + 6 * ppc); cy0 = jy + ny2 * (s1 + 6 * ppc);
    }
    var rot = phi * 180 / Math.PI - 90;
    if (!on(cx0, cy0) || !isFinite(rot) || rot < -75 || rot > 15) return null;
    return { x: cx0 / W, y: cy0 / H, rot: rot, mid: mid / W };
  }

  /* SP-KRAGEN (10.10.2026): „Kragen links“ / „Kragen rechts“ (Aris-Positionen a-kragen-*) auf dem Vorderfoto, Canvas Board 143 B:
     Feld parallel zur langen Außenkante des Kragenblatts, Fläche aus Aris („max. 8 × 2 cm“).
     Maßstab = Breite des Kragens ganz oben im Packshot (Kragen hinten, ca. 12,5 cm), weil bei Langarm die Rumpfbreite
     nur geschätzt ist. Standardlage (gemessen an Russell Z932F): Außenkante in cm ab Mitte/Oberkante von (7,7 | 4,5)
     bis zur Kragenspitze (6,4 | 12,8), Feldmitte auf halber Länge 1,2 cm nach innen.
     Kragenformen unterscheiden sich stark – Lage je Produkt im Metafeld custom.logo_vorschau (JSON):
       { "front": { "collar": { "x": 0.55, "y": 0.2, "rot": -80 } } }
     (x/y = Feldmitte „Kragen links“ als Anteil von Bildbreite/-höhe, in der Ansicht rechts; „Kragen rechts“ wird an der
     Kragenmitte gespiegelt; rot = Drehung in Grad). */
  var COLLAR_CM = 12.5, COLLAR_EDGE = [7.7, 4.5, 6.4, 12.8], COLLAR_T = 0.5, COLLAR_IN = 1.2, COLLAR_ZOOM = 3;
  function collarGeo(im) {
    var nw = im.naturalWidth, nh = im.naturalHeight;
    if (!nw || !nh) return null;
    var W = 300, H = Math.max(8, Math.round(300 * nh / nw));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bg = [0, 0, 0], n = 0, i, j;
    [[0, 0], [W - 3, 0], [0, H - 3], [W - 3, H - 3]].forEach(function (p) {
      for (var a = 0; a < 3; a++) for (var b = 0; b < 3; b++) {
        var q = ((p[1] + b) * W + p[0] + a) * 4;
        bg[0] += d[q]; bg[1] += d[q + 1]; bg[2] += d[q + 2]; n++;
      }
    });
    bg = bg.map(function (v) { return v / n; });
    function on(px, py) { var k = (py * W + px) * 4; return Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > 30; }
    var top = -1, ws = [], cs = [];
    for (j = 0; j < H && ws.length < Math.max(3, Math.round(H * 0.015)); j++) {
      var l = -1, r = -1;
      for (i = 0; i < W; i++) if (on(i, j)) { if (l < 0) l = i; r = i; }
      if (l < 0 || r - l < 4) { if (top >= 0) break; continue; }
      if (top < 0) { top = j; continue; } // erste Zeile auslassen (Kante)
      ws.push(r - l); cs.push((l + r) / 2);
    }
    if (top < 0 || !ws.length) return null;
    ws.sort(function (a, b) { return a - b; }); cs.sort(function (a, b) { return a - b; });
    var cw = ws[ws.length >> 1] / W;
    if (cw < 0.05 || cw > 0.3) return null;
    return { top: top / H, cw: cw, mid: cs[cs.length >> 1] / W };
  }

  /* SP-MUETZE (12.10.2026): Logo auf der Krempe von Mützen (Aris-Position „Krempe …“, Schlüssel a-krempe-*,
     Definition in assets/sp-pdp-neu.js applyAris). hatGeo() misst im frontalen Packshot die Mütze:
       Maßstab = Breite der Krempe (unterste Zeilen) ↔ HAT_CM cm,
       Oberkante der Krempe = von unten die erste Zeile, ab der die Mütze schmaler wird (Umschlag ist breiter),
       Feldmitte = Mitte der Krempe (waagerecht: Mitte der Krempe, senkrecht: halbe Krempenhöhe).
     Korrektur je Produkt im Metafeld custom.logo_vorschau: { "front": { "hat": { "x": 0.5, "y": 0.72, "cm": 21 } } }
     (x/y = Feldmitte als Anteil von Bildbreite/-höhe, cm = Breite der Krempe flach gelegt). */
  var HAT_CM = 21;
  function hatGeo(im) {
    var nw = im && im.naturalWidth, nh = im && im.naturalHeight;
    if (!nw || !nh) return null;
    var W = 240, H = Math.max(8, Math.round(240 * nh / nw));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bg = [0, 0, 0], n = 0, i, j, k;
    [[0, 0], [W - 3, 0], [0, H - 3], [W - 3, H - 3]].forEach(function (p) {
      for (var a = 0; a < 3; a++) for (var b = 0; b < 3; b++) {
        var q = ((p[1] + b) * W + p[0] + a) * 4;
        bg[0] += d[q]; bg[1] += d[q + 1]; bg[2] += d[q + 2]; n++;
      }
    });
    bg = bg.map(function (v) { return v / n; });
    var L = [], R = [], Wd = [], mx = 0;
    for (j = 0; j < H; j++) {
      var l = -1, r = -1;
      for (i = 0; i < W; i++) {
        k = (j * W + i) * 4;
        if (Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > 36) { if (l < 0) l = i; r = i; }
      }
      L.push(l); R.push(r); Wd.push(l < 0 ? 0 : r - l + 1);
      if (Wd[j] > mx) mx = Wd[j];
    }
    if (mx < W * 0.15) return null;
    var top = -1, bot = -1;
    for (j = 0; j < H; j++) { if (Wd[j] > 0.25 * mx && top < 0) top = j; if (Wd[j] > 0.5 * mx) bot = j; }
    var h = bot - top;
    if (top < 0 || h < H * 0.15) return null;
    function med(a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
    var ws = [], cs = [];
    for (j = bot - Math.round(h * 0.12); j <= bot - Math.round(h * 0.03); j++) { ws.push(Wd[j]); cs.push((L[j] + R[j]) / 2); }
    if (!ws.length) return null;
    var cw = med(ws), cx = med(cs), ct = -1;
    if (cw < 0.6 * mx) return null; // z. B. Schatten unter schräg fotografierten Mützen
    for (j = bot - Math.round(h * 0.15); j > top + h * 0.3; j--) {
      if ((Wd[j - 1] + Wd[j] + Wd[j + 1]) / 3 < 0.955 * cw) { ct = j; break; }
    }
    var ch = ct > 0 ? bot - ct : 0, conf = 'high';
    if (!(ch > h * 0.15 && ch < h * 0.55)) { ch = h * 0.36; conf = 'low'; }
    return { cx: cx / W, cy: (bot - ch / 2) / H, w: cw / W, conf: conf };
  }

  /* SP-CAP (17.10.2026, Canvas Board 249 „Caps: Logo live auf dem Foto“): Logo auf dem freigestellten Frontfoto der Cap
     (Hinten nur mit echtem Rückfoto). Die Cap-Positionen (Schlüssel a-vorne-mitte / a-vorne-links / a-vorne-rechts / a-hinten,
     Flag P.cap) legt assets/sp-pdp-neu.js an (applyAris, dort auch Druckfläche CAP_AREA/CAP_MAX und Startbreite CAP_W).
     capGeo() misst die Cap im Packshot (ohne Knopf):
       Krone  = von der Oberkante bis zur Zeile, ab der die Kontur sprunghaft breiter wird (der Schirm steht seitlich über),
       Maßstab = Kronenbreite dort ↔ CAP_CROWN_CM.
       Ohne erkennbaren Schirm (z. B. Rückfoto, schräge Fotos): Krone bis CAP_FB × Produkthöhe → Hinweis „Vorschau ungefähr“.
     CAP_ZONE: Feldmitte relativ zur Krone – x = Anteil der Kronenbreite ab Kronenmitte (+ = in der Ansicht rechts),
       y = Anteil der Kronenhöhe von oben, rot = Drehung in Grad (Seitenteile, Annäherung an die Perspektive).
       „Vorne links“ = Trägerseite links = in der Ansicht rechts (wie „Brust links“ bei Shirts, POS.links.fx > 0).
       Seitenteile rücken nach innen, falls das Feld sonst über die Kontur ragt (Abstand CAP_EDGE_CM).
     Korrektur je Produkt im Metafeld custom.logo_vorschau (JSON, Anteile von Bildbreite/-höhe):
       { "front": { "cap": { "top": 0.22, "cb": 0.64, "cx": 0.5, "cw": 0.62 } } }   (gleich für "back")
       top = Oberkante Krone, cb = Unterkante Krone (Schirmansatz außen), cx = Mitte, cw = Kronenbreite. */
  var CAP_CROWN_CM = 19.5; // Frontbreite der Krone frontal (Caps ca. 19–20 cm) → 8 cm Logo ≈ 41 % der Kronenbreite
  var CAP_EDGE_CM = 0.8;
  var CAP_ZONE = {
    mitte:  { x: 0,     y: 0.42, rot: 0 },  // Frontpanel mittig über dem Schirm (35–45 % der Kronenhöhe)
    links:  { x: 0.30,  y: 0.55, rot: 8 },  // Seitenteil, Trägerseite links = in der Ansicht rechts
    rechts: { x: -0.30, y: 0.55, rot: -8 }, // Seitenteil, Trägerseite rechts = in der Ansicht links
    hinten: { x: 0,     y: 0.50, rot: 0 }   // Rückfoto: Mitte über der Verschlussöffnung
  };
  var CAP_FB = { front: 0.62, back: 0.95 }; // Kronen-Unterkante ohne erkennbaren Schirm (Anteil der Produkthöhe)
  var CAP_GUESS = { front: { top: 0.22, cb: 0.62, cx: 0.5, cw: 0.56 }, back: { top: 0.22, cb: 0.78, cx: 0.5, cw: 0.6 } }; // solange das Foto nicht vermessen ist
  var CAP_NOTE = 'Die genaue Platzierung zeigen wir dir mit der Druckfreigabe, bevor wir produzieren.';
  function capGeo(im) {
    var nw = im.naturalWidth, nh = im.naturalHeight;
    if (!nw || !nh) return null;
    var W = 240, H = Math.max(8, Math.round(240 * nh / nw));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bg = [0, 0, 0], n = 0, i, j, k;
    [[0, 0], [W - 3, 0], [0, H - 3], [W - 3, H - 3]].forEach(function (p) {
      for (var a = 0; a < 3; a++) for (var b = 0; b < 3; b++) {
        var q = ((p[1] + b) * W + p[0] + a) * 4;
        bg[0] += d[q]; bg[1] += d[q + 1]; bg[2] += d[q + 2]; n++;
      }
    });
    bg = bg.map(function (v) { return v / n; });
    var L = [], R = [], Wd = [], mx = 0;
    for (j = 0; j < H; j++) {
      var l = -1, r = -1;
      for (i = 0; i < W; i++) {
        k = (j * W + i) * 4;
        if (Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > 36) { if (l < 0) l = i; r = i; }
      }
      L.push(l); R.push(r); Wd.push(l < 0 ? 0 : r - l + 1);
      if (Wd[j] > mx) mx = Wd[j];
    }
    if (mx < W * 0.15) return null;
    var top = -1, bot = -1;
    for (j = 0; j < H; j++) { if (Wd[j] > 0.2 * mx && top < 0) top = j; if (Wd[j] > 0.1 * mx) bot = j; }
    var h = bot - top;
    if (top < 0 || h < H * 0.15) return null;
    var S = [];
    for (j = 0; j < H; j++) S.push((Wd[Math.max(0, j - 1)] + Wd[j] + Wd[Math.min(H - 1, j + 1)]) / 3);
    // Schirmansatz: erste Zeile ab 40 % der Höhe, nach der die Kontur innerhalb von 3 Zeilen um > 5 % breiter wird
    var cb = -1;
    for (j = Math.round(top + 0.4 * h); j < bot - 3; j++) if (S[j + 3] - S[j] > 0.05 * mx) { cb = j; break; }
    if (cb > 0 && (S[cb] < 0.45 * mx || S[cb] > 0.97 * mx || (cb - top) / h > 0.92)) cb = -1;
    var cs = [], e = cb > 0 ? cb : Math.round(top + 0.6 * h);
    for (j = Math.round(top + 0.3 * h); j < e; j++) if (L[j] >= 0) cs.push((L[j] + R[j]) / 2);
    if (!cs.length) return null;
    cs.sort(function (p, q) { return p - q; });
    return {
      top: top / H, h: h / H, cb: cb > 0 ? cb / H : null, cw: cb > 0 ? S[cb] / W : null, cx: cs[cs.length >> 1] / W, n: H,
      S: S.map(function (v) { return v / W; }), L: L.map(function (v) { return v < 0 ? -1 : v / W; }), R: R.map(function (v) { return v < 0 ? -1 : v / W; })
    };
  }
  var capCache = typeof WeakMap === 'function' ? new WeakMap() : null;
  function capGeoOf(im) {
    if (!im || !im.naturalWidth || typeof HTMLImageElement === 'undefined' || !(im instanceof HTMLImageElement)) return null;
    if (capCache && capCache.has(im)) return capCache.get(im);
    var g = null;
    try { g = capGeo(im); } catch (e) { g = null; }
    if (capCache) capCache.set(im, g);
    return g;
  }
  function capRow(cg, yf) { return Math.max(0, Math.min(cg.n - 1, Math.round(yf * cg.n))); }

  /* ---------------- Hilfen ---------------- */
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : NaN; }
  function fmt(n) { return (Math.round(n * 10) / 10).toLocaleString('de-DE'); }
  function fname(u) { return String(u || '').split('?')[0].split('#')[0].split('/').pop().toLowerCase(); }
  function absUrl(u) { return !u ? '' : (u.indexOf('//') === 0 ? location.protocol + u : u); }
  // SP-POS-INFO (10.10.2026): Umschalter unter dem Foto + „i“-Hinweis an den Positions-Tasten
  function posInfoCss() {
    if (document.getElementById('splp-posinfo-css')) return;
    var c = document.createElement('style'); c.id = 'splp-posinfo-css';
    c.textContent =
      '.spn .splp-bar>.splp-toggle{position:static;display:flex;width:max-content;max-width:100%;margin:0 auto 12px;align-self:center}' +
      '@media (min-width:600px){.spn .splp-bar>.splp-toggle{height:32px}.spn .splp-bar>.splp-toggle button{padding:0 12px;font-size:12px;line-height:16px;letter-spacing:.1em}}' +
      '.spn .spn-pill.has-i{position:relative;padding-right:32px}' +
      '.spn .splp-i{position:absolute;top:50%;right:8px;transform:translateY(-50%);display:flex;cursor:help}' +
      '.spn .splp-i__ic{width:18px;height:18px;border-radius:50%;box-shadow:inset 0 0 0 1.25px currentColor;display:flex;align-items:center;justify-content:center;font-family:var(--head,inherit);font-size:11px;line-height:1;font-weight:700;font-style:normal;color:#5E656B}' +
      '.spn .splp-i__tip{display:none;position:absolute;bottom:calc(100% + 12px);left:50%;transform:translateX(calc(-50% + var(--dx,0px)));z-index:30;width:max-content;max-width:min(280px,calc(100vw - 24px));padding:12px 16px;border-radius:12px;background:#111111;color:#FFFFFF;font-size:14px;line-height:20px;font-weight:400;letter-spacing:0;text-transform:none;text-align:left;white-space:normal;box-shadow:0 8px 24px rgba(0,0,0,.18);pointer-events:none}' +
      '.spn .splp-i.is-open .splp-i__tip{display:block}';
    (document.head || document.documentElement).appendChild(c);
  }
  function mk(tag, cls, txt) { var d = document.createElement(tag); if (cls) d.className = cls; if (txt != null) d.textContent = txt; return d; }
  function hexLum(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return NaN;
    var v = parseInt(m[1], 16);
    return (0.2126 * (v >> 16 & 255) + 0.7152 * (v >> 8 & 255) + 0.0722 * (v & 255)) / 255;
  }
  function timeout(p, ms, fallback) {
    return Promise.race([p, new Promise(function (res) { setTimeout(function () { res(fallback); }, ms); })]);
  }

  /* ---------------- SP-BACK (2026-10-09): Rückseite ----------------
     1. echtes Rückenfoto der gewählten Farbe (Dateiname vorne→hinten: front/back, vorne/hinten, _f/_b,
        Stanley/Stella SFM…/PFM… → PBM0…; Shopify-Zusätze wie _<uuid> werden ignoriert),
     2. sonst ein Rückenfoto einer anderen Farbe desselben Produkts, umgefärbt auf die gewählte Farbe
        (Farbe aus der Brustmitte des Vorderfotos, Faltenwurf aus dem Rückenfoto),
     3. sonst nachgebildet aus dem Vorderfoto (window.spnMakeBack, assets/sp-pdp-de.js). */
  function baseKey(u) {
    return fname(u).replace(/\.[a-z0-9]+$/, '')
      .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
  }
  function backKeys(k) {
    var out = [k.replace(/front/g, 'back'), k.replace(/vorne/g, 'hinten'), k.replace(/_f$/, '_b'), k.replace(/^[sp]fm\d_/, 'pbm0_')];
    return out.filter(function (x, i) { return x !== k && out.indexOf(x) === i; });
  }
  function isBackKey(k) { return !/^sbm/.test(k) && /(^|[_-])back([_-]|$)|hinten|^pbm\d_|_b$/.test(k); }
  var recolorCache = {};
  function recolorBack(donorUrl, frontUrl, cap) {
    var key = donorUrl + '|' + frontUrl + (cap ? '|cap' : '');
    if (recolorCache[key]) return recolorCache[key];
    recolorCache[key] = Promise.all([loadImg(donorUrl), loadImg(frontUrl)]).then(function (r) {
      var back = r[0], front = r[1];
      function med(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
      // Zielfarbe: Median der Brustmitte im Vorderfoto (SP-CAP: Mitte des Frontpanels über dem Schirm)
      var f = document.createElement('canvas'); f.width = 100; f.height = 100;
      var fx = f.getContext('2d', { willReadFrequently: true }); fx.drawImage(front, 0, 0, 100, 100);
      var sr = [42, 45, 16, 15];
      if (cap) {
        var cg = capGeoOf(front);
        if (cg) { var ccb = cg.cb != null ? cg.cb : cg.top + CAP_FB.front * cg.h; sr = [Math.round(cg.cx * 100) - 6, Math.round((cg.top + 0.5 * (ccb - cg.top)) * 100) - 4, 12, 8]; }
      }
      var fd = fx.getImageData(sr[0], sr[1], sr[2], sr[3]).data, rs = [], gs = [], bs = [], i;
      for (i = 0; i < fd.length; i += 4) { rs.push(fd[i]); gs.push(fd[i + 1]); bs.push(fd[i + 2]); }
      var T = [med(rs), med(gs), med(bs)];
      var W = Math.min(1200, back.naturalWidth || 1200), H = Math.round(W * (back.naturalHeight || W) / (back.naturalWidth || W));
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, W, H); x.drawImage(back, 0, 0, W, H);
      var id = x.getImageData(0, 0, W, H), d = id.data, bg = [d[0], d[1], d[2]], Ls = [];
      function dist(k) { return Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]); }
      for (i = 0; i < d.length; i += 16) if (dist(i) > 60) Ls.push(0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]);
      if (!Ls.length) return null;
      var m = med(Ls), kk = Math.max(0.8, Math.min(2.2, 1 + (1 - m / 128))); // dunkle Vorlage: Falten stärker übertragen
      for (i = 0; i < d.length; i += 4) {
        var a = Math.max(0, Math.min(1, (dist(i) - 15) / 60));
        if (a <= 0) continue;
        var sh = (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2] - m) * kk;
        for (var ch = 0; ch < 3; ch++) {
          var v = Math.max(0, Math.min(255, T[ch] + sh));
          d[i + ch] = Math.round(d[i + ch] * (1 - a) + v * a);
        }
      }
      x.putImageData(id, 0, 0);
      return new Promise(function (res) { c.toBlob(function (b) { res(b ? URL.createObjectURL(b) : null); }, 'image/jpeg', 0.9); });
    }).catch(function () { return null; });
    return recolorCache[key];
  }

  /* ---------------- Fotos laden + Textil erkennen ---------------- */
  var imgCache = {};
  function loadImg(u) {
    u = absUrl(u);
    if (!imgCache[u]) {
      imgCache[u] = new Promise(function (res, rej) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onload = function () { res(im); };
        im.onerror = rej;
        im.src = u;
      });
    }
    return imgCache[u];
  }
  var infoCache = {};
  function getInfo(u, side) {
    u = absUrl(u);
    if (!u) return Promise.reject(new Error('no url'));
    if (!infoCache[u]) {
      infoCache[u] = loadImg(u).then(function (im) {
        var d = null, sl = null, cl = null, hg = null;
        try { d = detect(im); } catch (e) { d = null; }
        if (side === 'front') { try { hg = hatGeo(im); } catch (e) { hg = null; } } // SP-MUETZE
        if (SLEEVES) { try { sl = sleeveGeo(im, LONG, CHEST); } catch (e) { sl = null; } } // SP-AERMEL
        if (side === 'front') { try { cl = collarGeo(im); } catch (e) { cl = null; } } // SP-KRAGEN
        return { img: im, det: d, sl: sl, cl: cl, hg: hg };
      });
    }
    return infoCache[u].then(function (inf) {
      if (inf.det && inf.det.conf === 'high') lastGood[side] = inf.det;
      var cal = calib && calib[side];
      var det = cal && cal.tw ? { top: cal.top, ap: cal.ap, cx: cal.cx, tw: cal.tw, conf: 'high' }
        : (inf.det && inf.det.conf === 'high') ? inf.det : (lastGood[side] || inf.det || DEF_DET);
      return { url: u, img: inf.img, det: det, guessed: !inf.det, sl: (cal && cal.sleeve) || inf.sl || null, cl: inf.cl || null, clCal: (cal && cal.collar) || null, hg: inf.hg || null };
    });
  }

  // Sucht im Packshot die Kontur des Textils: Schulter-Oberkante, Achsel (Ende der Ärmel), Mittellinie, Rumpfbreite.
  function detect(im) {
    var nw = im.naturalWidth, nh = im.naturalHeight;
    if (!nw || !nh) return null;
    var s = 200 / Math.max(nw, nh), w = Math.max(8, Math.round(nw * s)), h = Math.max(8, Math.round(nh * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data;
    var bg = [0, 0, 0], n = 0;
    [[0, 0], [w - 3, 0], [0, h - 3], [w - 3, h - 3]].forEach(function (p) {
      for (var a = 0; a < 3; a++) for (var b = 0; b < 3; b++) {
        var k = ((p[1] + b) * w + p[0] + a) * 4;
        bg[0] += d[k]; bg[1] += d[k + 1]; bg[2] += d[k + 2]; n++;
      }
    });
    bg = bg.map(function (v) { return v / n; });
    var L = [], R = [], Wd = [], top = -1, bot = -1, i, j, k;
    for (j = 0; j < h; j++) {
      var l = -1, r = -1;
      for (i = 0; i < w; i++) {
        k = (j * w + i) * 4;
        if (Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > 42) { if (l < 0) l = i; r = i; }
      }
      L.push(l); R.push(r); Wd.push(l < 0 ? 0 : r - l);
      if (l >= 0 && r - l > 3) { if (top < 0) top = j; bot = j; }
    }
    if (top < 0 || (bot - top) / h < 0.4) return null;
    function med(a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
    // breiteste Zeile im oberen Teil = Ärmelspannweite; danach fällt die Breite an der Achsel stark ab
    var mx = 0, mr = top;
    for (j = top; j < top + (bot - top) * 0.6; j++) if (Wd[j] > mx) { mx = Wd[j]; mr = j; }
    var ap = -1;
    for (j = mr; j < bot; j++) if (Wd[j] < 0.72 * mx) { ap = j; break; }
    var ws = [], cs = [], conf = 'high';
    if (ap > top && (ap - top) / (bot - top) < 0.55) {
      for (j = ap + 2; j < Math.min(bot, ap + 12); j++) { ws.push(Wd[j]); cs.push((L[j] + R[j]) / 2); }
    } else {
      // lange Ärmel liegen am Körper an: Achsel geschätzt, Rumpf = Gesamtbreite ohne Ärmel
      conf = 'low';
      ap = Math.round(top + 0.3 * (bot - top));
      for (j = Math.round(top + 0.45 * (bot - top)); j < Math.round(top + 0.55 * (bot - top)); j++) { ws.push(Wd[j] / 1.5); cs.push((L[j] + R[j]) / 2); }
    }
    if (!ws.length) return null;
    var tw = med(ws) / w;
    if (tw < 0.15 || tw > 0.9) return null;
    return { top: top / h, ap: ap / h, cx: med(cs) / w, tw: tw, conf: conf };
  }

  /* ---------------- Logo-Dateien aufbereiten ---------------- */
  var logoCache = new WeakMap(), logoDone = new WeakMap();
  function getLogo(file) {
    if (!file) return Promise.resolve(null);
    var p = logoCache.get(file);
    if (p) return p;
    p = makeLogo(file).catch(function () { return { ph: true }; }).then(function (r) { logoDone.set(file, r); return r; });
    logoCache.set(file, p);
    return p;
  }
  function makeLogo(file) {
    var n = (file.name || '').toLowerCase(), t = file.type || '';
    if (/\.(png|jpe?g|gif|webp|svg)$/.test(n) || /^image\/(png|jpeg|gif|webp|svg)/.test(t)) {
      var url = URL.createObjectURL(file);
      return new Promise(function (res, rej) {
        var im = new Image();
        im.onload = function () { res(im); };
        im.onerror = rej;
        im.src = url;
      }).then(function (im) {
        var w = im.naturalWidth || 600, h = im.naturalHeight || 300;
        return finish(im, w, h);
      });
    }
    if (/\.(pdf|ai)$/.test(n) || t === 'application/pdf') {
      return renderPdf(file).then(function (c) { return finish(c, c.width, c.height); });
    }
    return Promise.resolve({ ph: true });
  }
  var pdfLib = null;
  function loadPdfJs() {
    if (pdfLib) return pdfLib;
    pdfLib = new Promise(function (res, rej) {
      if (window.pdfjsLib) return res(window.pdfjsLib);
      var s = document.createElement('script');
      s.src = PDFJS + 'pdf.min.js';
      s.async = true;
      s.onload = function () {
        var L = window.pdfjsLib || window['pdfjs-dist/build/pdf'];
        if (!L) return rej(new Error('pdf.js'));
        L.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
        res(L);
      };
      s.onerror = rej;
      document.head.appendChild(s);
    });
    return pdfLib;
  }
  function renderPdf(file) {
    return loadPdfJs().then(function (L) {
      return file.arrayBuffer().then(function (buf) { return L.getDocument({ data: new Uint8Array(buf) }).promise; });
    }).then(function (pdf) { return pdf.getPage(1); }).then(function (page) {
      var v0 = page.getViewport({ scale: 1 });
      var vp = page.getViewport({ scale: 1000 / Math.max(v0.width, v0.height) });
      var c = document.createElement('canvas');
      c.width = Math.ceil(vp.width); c.height = Math.ceil(vp.height);
      return page.render({ canvasContext: c.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise.then(function () { return c; });
    });
  }
  // Skaliert, stellt weißen Hintergrund frei (nur randverbunden) und schneidet auf den sichtbaren Inhalt zu.
  function finish(src, w, h) {
    var s = Math.min(1, 900 / Math.max(w, h));
    if (Math.max(w, h) < 300) s = 300 / Math.max(w, h);
    var cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(src, 0, 0, cw, ch);
    var id = x.getImageData(0, 0, cw, ch), d = id.data, opaque = true, k;
    for (k = 3; k < d.length; k += 4) if (d[k] < 250) { opaque = false; break; }
    if (opaque) { knockout(d, cw, ch); x.putImageData(id, 0, 0); }
    var L = cw, R = -1, T = ch, B = -1;
    for (var j = 0; j < ch; j++) for (var i = 0; i < cw; i++) {
      if (d[(j * cw + i) * 4 + 3] > 12) { if (i < L) L = i; if (i > R) R = i; if (j < T) T = j; if (j > B) B = j; }
    }
    if (R < L) return { ph: true };
    var tw = R - L + 1, th = B - T + 1, o = document.createElement('canvas');
    o.width = tw; o.height = th;
    o.getContext('2d').drawImage(c, L, T, tw, th, 0, 0, tw, th);
    return { canvas: o, url: o.toDataURL('image/png'), ar: th / tw };
  }
  function knockout(d, w, h) {
    var seen = new Uint8Array(w * h), q = new Int32Array(w * h), qs = 0, qe = 0, i;
    function white(p) { var k = p * 4; return d[k] > 232 && d[k + 1] > 232 && d[k + 2] > 232; }
    function push(p) { if (!seen[p] && white(p)) { seen[p] = 1; q[qe++] = p; } }
    for (i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
    for (i = 0; i < h; i++) { push(i * w); push(i * w + w - 1); }
    while (qs < qe) {
      var p = q[qs++], px = p % w, py = (p - px) / w;
      d[p * 4 + 3] = 0;
      if (px > 0) push(p - 1);
      if (px < w - 1) push(p + 1);
      if (py > 0) push(p - w);
      if (py < h - 1) push(p + w);
    }
  }

  /* ==========================================================================
     Pro Produktseite
     ========================================================================== */
  function init(el, cfg) {
    if (el.dataset.splpReady) return;
    var st = el.spnState;
    if (!st) return;
    el.dataset.splpReady = '1';
    el.classList.add('splp-on');

    var spnData = {};
    try { spnData = JSON.parse(el.querySelector('[data-spn-data]').textContent); } catch (e) {}
    var colorMap = {};
    (spnData.colors || []).forEach(function (c) { colorMap[c.name] = c; });
    var media = (cfg.media || []).filter(Boolean).map(absUrl);
    var chestCm = num(cfg.chestCm) > 0 ? num(cfg.chestCm) : 50;
    calib = cfg.calib && typeof cfg.calib === 'object' ? cfg.calib : null;
    if (cfg.positions && typeof cfg.positions === 'object') {
      Object.keys(cfg.positions).forEach(function (k) {
        var v = cfg.positions[k];
        if (POS[k] && v && typeof v === 'object') Object.keys(v).forEach(function (f) { if (f !== 'side' && f !== 'label') POS[k][f] = v[f]; });
      });
    }

    // SP-AERMEL (2026-10-09): Ärmel nur für die Produktarten aus der Section-Einstellung (cfg.sleeves)
    SLEEVES = cfg.sleeves === true;
    // SP-AERMEL-SWEAT (12.10.2026): Langarm-Produktarten (Hoodies, Sweat, Strick) kommen als cfg.long aus der Section
    LONG = cfg.long === true || /long\s*sleeve|langarm/i.test(String(cfg.title || ''));
    CHEST = chestCm;
    if (SLEEVES) {
      POS['a-aermel-links'] = { label: 'Ärmel links', side: 'front', sleeve: 1, fx: 0, fy: 0, min: 0, area: [10, 10], w: 8, ph: 1 };
      POS['a-aermel-rechts'] = { label: 'Ärmel rechts', side: 'front', sleeve: -1, fx: 0, fy: 0, min: 0, area: [10, 10], w: 8, ph: 1 };
    }
    // SP-KRAGEN: Kragen-Positionen (nur aktiv, wenn der Aris-Optionssatz „Kragen links/rechts“ hat)
    POS['a-kragen-links'] = { label: 'Kragen links', side: 'front', collar: 1, fx: 0, fy: 0, min: 0, area: [7, 2], w: 6, ph: 0.25 };
    POS['a-kragen-rechts'] = { label: 'Kragen rechts', side: 'front', collar: -1, fx: 0, fy: 0, min: 0, area: [7, 2], w: 6, ph: 0.25 };
    // Druckfläche der Ärmel aus dem Aris-Optionssatz („max. 10 × 10 cm“), sobald sp-pdp-neu.js ihn gelesen hat
    function arisArea(k) {
      var A = el.spnAris || [];
      for (var a = 0; a < A.length; a++) for (var b = 0; b < A[a].pos.length; b++) if (A[a].pos[b].key === k && A[a].pos[b].area) return A[a].pos[b].area;
      return null;
    }

    // SP-ARIS (2026-10-02): Positionen, die nicht in POS stehen (z. B. „Nacken“ aus dem Aris-Optionssatz),
    // liefert sp-pdp-neu.js über el.spnPosDefs. Ohne Eintrag wird das Logo im Foto nicht gezeichnet.
    function PZ(k) {
      var P = POS[k];
      if (P && (P.sleeve || P.collar)) { var ar = arisArea(k); if (ar) P.area = ar; }
      return P || (el.spnPosDefs && el.spnPosDefs[k]) || null;
    }

    var stage = el.querySelector('.spn-stage');
    var stageImg = el.querySelector('[data-spn-stage-img]');
    if (!stage || !stageImg) return;

    var S = { mode: 'mock', side: 'front', zoom: false, zf: 1, active: 0, color: st.active, front: '', back: '', backSymbol: false, info: {}, ppc: 1 };

    /* ---------- DOM: Ebene auf dem Foto ---------- */
    var layer = mk('div', 'splp-layer');
    var backWrap = mk('div', 'splp-backwrap'); backWrap.hidden = true;
    var backImg = mk('img'); backImg.alt = ''; backImg.decoding = 'async';
    backWrap.appendChild(backImg);
    var NS = 'http://www.w3.org/2000/svg';
    var guides = document.createElementNS(NS, 'svg'); guides.setAttribute('class', 'splp-guides'); guides.setAttribute('aria-hidden', 'true');
    var gArea = document.createElementNS(NS, 'rect'); gArea.setAttribute('fill', 'none'); gArea.setAttribute('stroke-width', '1'); gArea.setAttribute('stroke-dasharray', '4 4');
    var gLine = document.createElementNS(NS, 'path'); gLine.setAttribute('fill', 'none'); gLine.setAttribute('stroke-width', '1.5');
    guides.appendChild(gArea); guides.appendChild(gLine);
    var logosBox = mk('div', 'splp-logos');
    var tag = mk('span', 'splp-tag'); tag.hidden = true;
    layer.appendChild(backWrap); layer.appendChild(guides); layer.appendChild(logosBox); layer.appendChild(tag);
    stage.appendChild(layer);

    var toggle = mk('div', 'splp-toggle'); toggle.setAttribute('role', 'group'); toggle.setAttribute('aria-label', 'Ansicht');
    var btnF = mk('button', '', 'Vorne'), btnB = mk('button', '', 'Hinten'), btnA = mk('button', '', 'Ärmel'), btnK = mk('button', '', 'Kragen');
    btnF.type = btnB.type = btnA.type = btnK.type = 'button';
    btnA.hidden = true; // SP-AERMEL: Detailansicht, nur sichtbar, wenn ein Logo am Ärmel sitzt
    btnK.hidden = true; // SP-KRAGEN: Detailansicht, nur bei Produkten mit Kragen-Positionen
    toggle.appendChild(btnF); toggle.appendChild(btnB); toggle.appendChild(btnA); toggle.appendChild(btnK);
    // SP-POS-INFO (10.10.2026): Umschalter nicht mehr oben rechts im Foto, sondern kleiner und zentriert darunter (siehe Leiste)
    btnF.addEventListener('click', function () { show('front'); });
    btnB.addEventListener('click', function () { show('back'); });
    btnA.addEventListener('click', function () { show('front', 'arm'); });
    btnK.addEventListener('click', function () { show('front', 'collar'); });

    /* ---------- DOM: Leiste unter dem Foto ---------- */
    var bar = mk('div', 'splp-bar');
    var colorsBox = mk('div', 'splp-colors'); colorsBox.hidden = true;
    colorsBox.appendChild(mk('span', 'splp-colors__t', 'In deinen Farben ansehen'));
    var colorsRow = mk('div', 'splp-colors__row'); colorsRow.setAttribute('role', 'group'); colorsRow.setAttribute('aria-label', 'Vorschau in deinen Farben');
    colorsBox.appendChild(colorsRow);
    var hint = mk('div', 'splp-hint');
    var hintRow = mk('p', 'splp-hint__row'); hintRow.style.margin = '0';
    var hintTxt = mk('span');
    var resetBtn = mk('button', 'splp-link', 'Position zurücksetzen'); resetBtn.type = 'button'; resetBtn.hidden = true;
    hintRow.appendChild(hintTxt); hintRow.appendChild(resetBtn);
    var warn = mk('p', 'splp-warn'); warn.style.margin = '0'; warn.setAttribute('role', 'status');
    hint.appendChild(hintRow); hint.appendChild(warn);
    bar.appendChild(toggle); bar.appendChild(colorsBox); bar.appendChild(hint);
    stage.parentNode.insertBefore(bar, stage.nextSibling);
    posInfoCss();
    resetBtn.addEventListener('click', function () {
      var lg = st.logos[S.active];
      if (lg && lg._splp) { lg._splp.dx = 0; lg._splp.dy = 0; }
      render(); scheduleMinis();
    });

    /* ---------- DOM: Mini-Vorschau in Schritt 3 ---------- */
    var minis = null, miniF = null, miniB = null;
    var logosCards = el.querySelector('[data-spn-logos]');
    if (cfg.minis !== false && logosCards) {
      minis = mk('div', 'splp-minis');
      miniF = makeMini('front', 'Vorne'); miniB = makeMini('back', 'Hinten');
      minis.appendChild(miniF.btn); minis.appendChild(miniB.btn);
      logosCards.parentNode.insertBefore(minis, logosCards);
    }
    function makeMini(side, label) {
      var b = mk('button', 'splp-mini'); b.type = 'button';
      b.setAttribute('aria-label', 'Vorschau ' + label + ' groß zeigen');
      var c = document.createElement('canvas'); c.width = 400; c.height = 400;
      b.appendChild(c); b.appendChild(mk('span', '', label));
      b.addEventListener('click', function () {
        show(side);
        var r = stage.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.5) {
          window.scrollTo({ top: r.top + window.pageYOffset - 96, behavior: 'smooth' });
        }
      });
      return { btn: b, canvas: c, side: side };
    }

    /* ---------- Zustand ---------- */
    function fileOf(lg) { return st.later ? null : (lg.file || null); }
    function logoOf(lg) { var f = fileOf(lg); return f ? (logoDone.get(f) || null) : null; }
    function meta(lg) {
      if (!lg._splp) lg._splp = { pos: lg.pos, dx: 0, dy: 0 };
      return lg._splp;
    }
    function sizeCm(lg) {
      var P = PZ(lg.pos) || POS.links, w = num(lg.width);
      if (!(w > 0)) w = P.w;
      w = Math.max(1, Math.min(60, w));
      var lo = logoOf(lg);
      return { w: w, h: w * (lo && lo.ar ? lo.ar : P.ph) };
    }
    function sideUrl(side) { return side === 'back' ? S.back : S.front; }
    function updateUrls() {
      var c = colorMap[st.active];
      var f = absUrl(c && c.image) || absUrl(S.front) || absUrl(stageImg.currentSrc || stageImg.src);
      var fk = f ? baseKey(f) : '', b = '', donor = '', i;
      if (fk) {
        var cands = backKeys(fk);
        for (i = 0; i < media.length && !b; i++) if (cands.indexOf(baseKey(media[i])) >= 0) b = media[i];
        // SP-BACK: Rückenfoto einer anderen Farbe als Vorlage (Packshot, kein Modelfoto)
        for (i = 0; i < media.length && !b && !donor; i++) if (isBackKey(baseKey(media[i]))) donor = media[i];
      }
      S.front = f; S.back = b || f; S.backSymbol = !b;
      var want = f, tok = S.tok = (S.tok || 0) + 1;
      function useBack(u) {
        if (!u || S.front !== want) return false;
        if (S.cap && S.tok !== tok) return false; // SP-CAP: Ergebnis einer älteren Suche (z. B. vor der Cap-Erkennung)
        S.back = u; S.backSymbol = false;
        getInfo(u, 'back').then(function (inf) {
          if (S.back === inf.url) { S.info.back = inf; render(); scheduleMinis(); }
        }).catch(function () {});
        return true;
      }
      function synth() {
        // SP-BACKVIEW (2026-09-29): kein Rückenfoto → Rückseite aus dem Vorderfoto nachbilden (window.spnMakeBack, assets/sp-pdp-de.js)
        if (typeof window.spnMakeBack === 'function') window.spnMakeBack(f).then(useBack).catch(function () {});
      }
      if (S.cap) {
        // SP-CAP: Rückseite nur aus einem echten Rückfoto (dieser Farbe, Metafeld custom.rueckansicht_bilder oder – umgefärbt –
        // einer anderen Farbe); keine aus dem Frontfoto nachgebildete Rückseite. Ohne Rückfoto: kein Umschalter „Hinten“.
        var real = !b && f && typeof window.spnRealBack === 'function' ? absUrl(window.spnRealBack(f) || '') : '';
        if (real) { S.back = real; S.backSymbol = false; }
        else if (!b && f && donor) recolorBack(donor, f, true).then(function (u) { if (useBack(u)) render(); }).catch(function () {});
      } else if (!b && f) {
        if (donor) recolorBack(donor, f).then(function (u) { if (!useBack(u)) { if (!u && S.front === want) synth(); } }).catch(synth);
        else synth();
      }
      ['front', 'back'].forEach(function (side) {
        var u = sideUrl(side);
        if (!u) return;
        getInfo(u, side).then(function (inf) {
          if (sideUrl(side) === inf.url) { S.info[side] = inf; render(); scheduleMinis(); }
        }).catch(function () {});
      });
    }
    function infoFor(side) {
      var inf = S.info[side];
      if (inf && inf.url === absUrl(sideUrl(side))) return inf;
      var im = side === 'front' ? stageImg : backImg;
      var cal = calib && calib[side];
      return { img: { naturalWidth: im.naturalWidth || 1, naturalHeight: im.naturalHeight || 1 }, det: (cal && cal.tw ? cal : null) || lastGood[side] || DEF_DET, clCal: (cal && cal.collar) || null };
    }
    function shirtLum() {
      var c = colorMap[st.active], l = hexLum(c && c.hex);
      return isFinite(l) ? l : 0.3;
    }

    /* ---------- Geometrie (für Foto, Mini und Warenkorbbild gleich) ---------- */
    function layout(side, W, H, info) {
      var nw = info.img.naturalWidth || 1, nh = info.img.naturalHeight || 1, det = info.det || DEF_DET;
      var s = Math.min(W / nw, H / nh), rw = nw * s, rh = nh * s, ox = (W - rw) / 2, oy = (H - rh) / 2;
      var top = oy + det.top * rh, ap = oy + (det.ap != null ? det.ap : det.top + 0.3) * rh, tw = det.tw * rw;
      var g = { ox: ox, oy: oy, rw: rw, rh: rh, ppc: tw / chestCm, top: top, ap: ap, cx: ox + det.cx * rw, tw: tw, conf: det.conf || 'high' };
      var drop = Math.max(1, ap - top);
      var items = [];
      st.logos.forEach(function (lg, i) {
        var P = PZ(lg.pos);
        if (!P || P.side !== side) return;
        var sz = sizeCm(lg), o = meta(lg);
        if (P.sleeve || P.collar || P.hat || P.cap) { items.push(sleeveItem(i, lg, P, sz, o, g, info)); return; } // SP-AERMEL / SP-KRAGEN / SP-MUETZE / SP-CAP
        var wpx = sz.w * g.ppc, hpx = sz.h * g.ppc, mid = g.cx + P.fx * tw;
        var bx = mid - wpx / 2, by = top + P.fy * drop;
        // Druckfläche mittig um die Standardlage des Logos
        var aw = P.area[0] * g.ppc, ah = P.area[1] * g.ppc, ax = mid - aw / 2, ay = by - Math.max(0, ah - hpx) / 2;
        ay = Math.min(by, Math.max(ay, top + (P.min || 0) * drop));
        // Verschiebung (cm) auf die Druckfläche begrenzen
        var x = bx + o.dx * g.ppc, y = by + o.dy * g.ppc;
        x = wpx <= aw ? Math.max(ax, Math.min(ax + aw - wpx, x)) : bx;
        y = hpx <= ah ? Math.max(ay, Math.min(ay + ah - hpx, y)) : by;
        o.dx = Math.round((x - bx) / g.ppc * 2) / 2;
        o.dy = Math.round((y - by) / g.ppc * 2) / 2;
        items.push({
          i: i, lg: lg, P: P, cm: sz, logo: logoOf(lg),
          x: bx + o.dx * g.ppc, y: by + o.dy * g.ppc, w: wpx, h: hpx,
          area: { x: ax, y: ay, w: aw, h: ah }
        });
      });
      return { g: g, items: items };
    }

    /* SP-AERMEL: Ärmel-Logo – Feld um die gemessene Ärmelmitte, gedreht parallel zur Ärmelnaht.
       Verschiebung o.dx/o.dy in cm im gedrehten Feld (dx entlang der Naht, dy Richtung Saum). */
    function sleeveAt(info, g, sign) {
      var s = info.sl;
      if (s && isFinite(s.x) && isFinite(s.y)) {
        var m = isFinite(s.mid) ? s.mid : ((info.det && info.det.cx) || 0.5), rot = isFinite(s.rot) ? s.rot : -28;
        return { px: g.ox + (sign > 0 ? s.x : 2 * m - s.x) * g.rw, py: g.oy + s.y * g.rh, rot: sign > 0 ? rot : -rot };
      }
      var drop = Math.max(1, g.ap - g.top); // Ersatzlage, solange das Foto noch nicht vermessen ist
      return { px: g.cx + sign * 0.735 * g.tw, py: g.top + 0.62 * drop + 4 * g.ppc, rot: -28 * sign };
    }
    /* SP-KRAGEN: Feldmitte, Drehung und Maßstab am Kragen (siehe collarGeo) */
    function collarAt(info, g, sign) {
      var cc = info.clCal, cl = info.cl, k = g.ppc, cx = g.cx, top = g.top, m = (info.det && info.det.cx) || 0.5;
      if (cl) { k = cl.cw * g.rw / COLLAR_CM; cx = g.ox + cl.mid * g.rw; top = g.oy + cl.top * g.rh; m = cl.mid; }
      if (cc && isFinite(cc.x) && isFinite(cc.y)) {
        var rc = isFinite(cc.rot) ? cc.rot : -80;
        return { px: g.ox + (sign > 0 ? cc.x : 2 * m - cc.x) * g.rw, py: g.oy + cc.y * g.rh, rot: sign > 0 ? rc : -rc, ppc: k };
      }
      var E = COLLAR_EDGE, ux = E[2] - E[0], uy = E[3] - E[1], L = Math.sqrt(ux * ux + uy * uy);
      ux /= L; uy /= L;
      // Feldmitte auf der Außenkante, dann nach innen (zur Mitte); Drehung parallel zur Kante, Schrift nie kopfüber
      var mx = E[0] + (E[2] - E[0]) * COLLAR_T - uy * COLLAR_IN, my = E[1] + (E[3] - E[1]) * COLLAR_T + ux * COLLAR_IN;
      var rot = Math.atan2(-uy, -ux) * 180 / Math.PI;
      if (rot < -90) rot += 180; else if (rot > 90) rot -= 180;
      return { px: cx + sign * mx * k, py: top + my * k, rot: sign > 0 ? rot : -rot, ppc: k };
    }
    /* SP-MUETZE: Feldmitte und Maßstab auf der Krempe (siehe hatGeo) */
    function hatAt(info, g) {
      var cal = calib && calib.front && calib.front.hat, h = info.hg || { cx: 0.5, cy: 0.68, w: 0.62, conf: 'low' };
      var cm = cal && num(cal.cm) > 0 ? num(cal.cm) : HAT_CM;
      var x = cal && isFinite(cal.x) ? cal.x : h.cx, y = cal && isFinite(cal.y) ? cal.y : h.cy;
      return { px: g.ox + x * g.rw, py: g.oy + y * g.rh, rot: 0, ppc: Math.max(0.5, h.w * g.rw / cm), low: !(cal && isFinite(cal.y)) && h.conf === 'low' };
    }
    /* SP-CAP: Feldmitte, Drehung und Maßstab auf der Cap (siehe capGeo / CAP_ZONE) */
    function capAt(info, g, P) {
      var Z = CAP_ZONE[P.cap] || CAP_ZONE.mitte, side = P.side === 'back' ? 'back' : 'front';
      var cal = calib && calib[side] && calib[side].cap, cg = capGeoOf(info.img), G = CAP_GUESS[side];
      var c = { top: G.top, cb: G.cb, cx: G.cx, cw: G.cw }, low = true;
      if (cg) {
        var cbf = cg.cb != null ? cg.cb : cg.top + CAP_FB[side] * cg.h;
        c = { top: cg.top, cb: cbf, cx: cg.cx, cw: cg.cb != null ? cg.cw : cg.S[capRow(cg, cbf)] };
        low = cg.cb == null;
      }
      if (cal && typeof cal === 'object') {
        ['top', 'cb', 'cx', 'cw'].forEach(function (f) { if (isFinite(num(cal[f]))) c[f] = num(cal[f]); });
        if (isFinite(num(cal.top)) && isFinite(num(cal.cb)) && isFinite(num(cal.cw))) low = false;
      }
      var cw = Math.max(1, c.cw * g.rw), k = Math.max(0.5, cw / CAP_CROWN_CM), mid = g.ox + c.cx * g.rw;
      var px = mid + Z.x * cw, py = g.oy + (c.top + Z.y * (c.cb - c.top)) * g.rh;
      if (Z.x && cg) {
        // Seitenteil: Feld innerhalb der Kontur halten (engste Stelle über die Feldhöhe)
        var sg = Z.x > 0 ? 1 : -1, ah = (P.area ? P.area[1] : 5) * k, hw = Infinity;
        [-0.5, 0, 0.5].forEach(function (t) {
          var j = capRow(cg, (py + t * ah - g.oy) / g.rh), e = sg > 0 ? cg.R[j] : cg.L[j];
          if (e >= 0) hw = Math.min(hw, (sg > 0 ? e - c.cx : c.cx - e) * g.rw);
        });
        var lim = hw - ((P.area ? P.area[0] : 5) / 2 + CAP_EDGE_CM) * k;
        if (isFinite(hw) && Math.abs(px - mid) > lim) px = mid + sg * Math.max(0.12 * cw, lim);
      }
      return { px: px, py: py, rot: Z.rot, ppc: k, low: low };
    }
    // nur Krempen-Positionen im Optionssatz → keine Rückansicht
    function hatOnly() {
      var A = el.spnAris, any = false, other = false;
      if (!A) return false;
      A.forEach(function (a) { a.pos.forEach(function (p) { var P = PZ(p.key); if (P && P.hat) any = true; else other = true; }); });
      return any && !other;
    }
    function zoomKind(P) { return P ? (P.sleeve ? 'arm' : (P.collar ? 'collar' : false)) : false; }
    function sleeveItem(i, lg, P, sz, o, g, info) {
      var sg = P.cap ? capAt(info, g, P) : P.hat ? hatAt(info, g) : (P.collar ? collarAt(info, g, P.collar) : sleeveAt(info, g, P.sleeve));
      var kp = sg.ppc || g.ppc;
      var wpx = sz.w * kp, hpx = sz.h * kp, aw = P.area[0] * kp, ah = P.area[1] * kp;
      var lx = Math.max(0, (aw - wpx) / 2 / kp), ly = Math.max(0, (ah - hpx) / 2 / kp);
      o.dx = Math.max(-lx, Math.min(lx, Math.round(o.dx * 2) / 2));
      o.dy = Math.max(-ly, Math.min(ly, Math.round(o.dy * 2) / 2));
      o.rot = sg.rot;
      var r = sg.rot * Math.PI / 180, cs = Math.cos(r), sn = Math.sin(r);
      var cx = sg.px + (o.dx * cs - o.dy * sn) * kp, cy = sg.py + (o.dx * sn + o.dy * cs) * kp;
      return {
        i: i, lg: lg, P: P, cm: sz, logo: logoOf(lg), k: kp, low: !!sg.low,
        x: cx - wpx / 2, y: cy - hpx / 2, w: wpx, h: hpx, rot: sg.rot, pivot: { x: sg.px, y: sg.py },
        area: { x: sg.px - aw / 2, y: sg.py - ah / 2, w: aw, h: ah }
      };
    }
    function isSleeve(lg, kind) { var P = lg && PZ(lg.pos); return !!P && zoomKind(P) === (kind || 'arm'); }
    // SP-KRAGEN: Knopf „Kragen“ nur, wenn der Aris-Optionssatz Kragen-Positionen hat
    function colAvail() {
      var A = el.spnAris;
      if (!A) return false;
      for (var a = 0; a < A.length; a++) for (var b = 0; b < A[a].pos.length; b++) if (POS[A[a].pos[b].key] && POS[A[a].pos[b].key].collar) return true;
      return false;
    }
    // SP-AERMEL: Knopf „Ärmel“ immer zeigen, wenn das Produkt Ärmel-Positionen hat (vor dem Laden von Aris: annehmen)
    function armAvail() {
      if (!SLEEVES) return false;
      var A = el.spnAris;
      if (!A) return true;
      for (var a = 0; a < A.length; a++) for (var b = 0; b < A[a].pos.length; b++) if (POS[A[a].pos[b].key] && POS[A[a].pos[b].key].sleeve) return true;
      return false;
    }
    // Detailansicht: Foto + Ebene vergrößert auf das Ärmel-Logo (Ausschnitt bleibt in der Bildfläche)
    function setZoom(it, W, H, g) {
      var t = '';
      S.zf = 1;
      if (it) {
        var Z = it.P.collar ? COLLAR_ZOOM : ZOOM, zx = it.pivot.x - (it.P.sleeve || 0) * 3 * g.ppc, zy = it.pivot.y;
        var tx = Math.max(W - W * Z, Math.min(0, W / 2 - zx * Z)), ty = Math.max(H - H * Z, Math.min(0, H / 2 - zy * Z));
        t = 'translate(' + tx + 'px,' + ty + 'px) scale(' + Z + ')';
        S.zf = Z;
      }
      stage.classList.toggle('splp-zoom', !!it);
      if (stageImg.style.transform !== t) stageImg.style.transform = t;
      if (layer.style.transform !== t) layer.style.transform = t;
    }

    /* ---------- Foto-Ebene zeichnen ---------- */
    var pool = [];
    function logoEl(i) {
      if (pool[i]) return pool[i];
      var d = mk('div', 'splp-logo');
      d.tabIndex = 0;
      d.setAttribute('role', 'img');
      d.dataset.i = String(i);
      d.addEventListener('pointerdown', startDrag);
      d.addEventListener('keydown', keyMove);
      d.addEventListener('focus', function () { S.active = +d.dataset.i; render(); });
      logosBox.appendChild(d);
      pool[i] = d;
      return d;
    }
    function render() {
      var mock = S.mode === 'mock';
      var hasArm = armAvail(), hasCol = colAvail(), hatO = hatOnly();
      var capNB = !!S.cap && S.backSymbol; // SP-CAP: Cap ohne Rückfoto → kein „Hinten“ im Foto
      btnB.hidden = hatO || capNB; // SP-MUETZE / SP-CAP
      if (minis) miniB.btn.hidden = hatO || capNB;
      if ((hatO || capNB) && S.side === 'back') S.side = 'front';
      // SP-CAP: Logos „Hinten“ ohne Rückfoto haben keine Bildvorschau (Lage-Schnellwahl und Verschiebung entfallen, sp-logo-place.js)
      var capOff = false;
      if (S.cap) {
        st.logos.forEach(function (lg) {
          var m = lg._splp, Pq = PZ(lg.pos);
          if (!m) return;
          m.nophoto = !!(capNB && Pq && Pq.side === 'back');
          if (m.nophoto) { m.dx = 0; m.dy = 0; }
        });
        var la = st.logos[S.active], Pa = la && PZ(la.pos);
        capOff = mock && capNB && !!Pa && Pa.side === 'back';
      }
      if ((S.zoom === 'arm' && !hasArm) || (S.zoom === 'collar' && !hasCol)) S.zoom = false;
      btnA.hidden = !hasArm;
      btnK.hidden = !hasCol;
      btnF.setAttribute('aria-pressed', mock && S.side === 'front' && !S.zoom ? 'true' : 'false');
      btnB.setAttribute('aria-pressed', mock && S.side === 'back' ? 'true' : 'false');
      btnA.setAttribute('aria-pressed', mock && S.side === 'front' && S.zoom === 'arm' ? 'true' : 'false');
      btnK.setAttribute('aria-pressed', mock && S.side === 'front' && S.zoom === 'collar' ? 'true' : 'false');
      layer.hidden = !mock;
      hint.hidden = !mock;
      renderColors();
      if (minis) {
        miniF.btn.setAttribute('aria-pressed', mock && S.side === 'front' ? 'true' : 'false');
        miniB.btn.setAttribute('aria-pressed', mock && S.side === 'back' ? 'true' : 'false');
      }
      if (!mock) { setZoom(null); return; }
      if (capOff) {
        // SP-CAP: statt Logo im Foto der Hinweis zur Druckfreigabe (EN über assets/sp-i18n-en.js)
        layer.hidden = true; setZoom(null);
        hintTxt.textContent = CAP_NOTE; hintTxt.hidden = false;
        resetBtn.hidden = true; warn.textContent = ''; warn.hidden = true;
        return;
      }

      var side = S.side;
      backWrap.hidden = side !== 'back';
      if (side === 'back' && backImg.getAttribute('src') !== S.back) backImg.src = S.back;

      var W = stage.clientWidth, H = stage.clientHeight;
      var L = layout(side, W, H, infoFor(side));
      S.ppc = L.g.ppc;
      S.kp = {};
      L.items.forEach(function (it) { if (it.k) S.kp[it.i] = it.k; });
      var act = null;
      L.items.forEach(function (it) { if (it.i === S.active) act = it; });
      if (!act && L.items.length) act = L.items[0];
      // SP-AERMEL: Detailansicht auf das (aktive) Ärmel-Logo
      var zIt = null, ghost = null;
      if (S.zoom && side === 'front') {
        var zk = S.zoom, gk = zk === 'collar' ? 'a-kragen-links' : 'a-aermel-links';
        if (act && zoomKind(act.P) === zk) zIt = act; else L.items.forEach(function (it) { if (!zIt && zoomKind(it.P) === zk) zIt = it; });
        if (zIt) act = zIt;
        else if (POS[gk]) {
          // noch kein Logo am Ärmel / Kragen: leeres Feld links zeigen
          var Pg = PZ(gk), sg = zk === 'collar' ? collarAt(infoFor('front'), L.g, 1) : sleeveAt(infoFor('front'), L.g, 1), gp = sg.ppc || L.g.ppc;
          ghost = { P: Pg, rot: sg.rot, pivot: { x: sg.px, y: sg.py }, area: { x: sg.px - Pg.area[0] * gp / 2, y: sg.py - Pg.area[1] * gp / 2, w: Pg.area[0] * gp, h: Pg.area[1] * gp } };
          zIt = ghost; act = null;
        }
      }
      setZoom(zIt, W, H, L.g);

      pool.forEach(function (d) { d.hidden = true; });
      L.items.forEach(function (it) {
        var d = logoEl(it.i), lo = it.logo;
        d.hidden = false;
        d.style.left = it.x + 'px'; d.style.top = it.y + 'px';
        d.style.width = it.w + 'px'; d.style.height = it.h + 'px';
        d.style.transform = it.rot ? 'rotate(' + it.rot + 'deg)' : ''; // SP-AERMEL
        d.classList.toggle('is-active', it === act);
        d.setAttribute('aria-label', 'Logo ' + (it.i + 1) + ', ' + it.P.label + ', ' + fmt(it.cm.w) + ' cm breit. Mit Maus, Finger oder Pfeiltasten verschieben.');
        if (lo && lo.url) {
          d.classList.remove('is-ph');
          var im = d.querySelector('img');
          if (!im) { d.textContent = ''; im = mk('img'); im.alt = ''; im.draggable = false; d.appendChild(im); }
          if (im.getAttribute('src') !== lo.url) im.src = lo.url;
        } else {
          d.classList.add('is-ph');
          var t = it.w >= 56 ? 'Logo ' + (it.i + 1) : String(it.i + 1);
          if (d.textContent !== t) d.textContent = t;
        }
      });

      // Druckfläche + Maßlinie + Etikett für das aktive Logo
      var lum = shirtLum(), gc = lum > 0.6 ? INK : '#FFFFFF';
      var showArea = cfg.area !== false && (act || ghost);
      guides.style.display = showArea ? '' : 'none';
      tag.hidden = !act;
      if (ghost && showArea) {
        gArea.setAttribute('x', ghost.area.x); gArea.setAttribute('y', ghost.area.y);
        gArea.setAttribute('width', ghost.area.w); gArea.setAttribute('height', ghost.area.h);
        gArea.setAttribute('stroke', shirtLum() > 0.6 ? INK : '#FFFFFF'); gArea.setAttribute('stroke-opacity', '0.75');
        gArea.setAttribute('transform', 'rotate(' + ghost.rot + ' ' + ghost.pivot.x + ' ' + ghost.pivot.y + ')');
        gLine.setAttribute('d', '');
      }
      if (act) {
        if (showArea) {
          gArea.setAttribute('x', act.area.x); gArea.setAttribute('y', act.area.y);
          gArea.setAttribute('width', act.area.w); gArea.setAttribute('height', act.area.h);
          gArea.setAttribute('stroke', gc); gArea.setAttribute('stroke-opacity', '0.75');
        }
        var above = act.rot ? true : act.y - 44 > 0;
        var ly = above ? act.y - 10 : act.y + act.h + 10;
        var lcx = act.x + act.w / 2, lcy = act.y + act.h / 2;
        if (showArea) {
          gLine.setAttribute('d', 'M' + act.x + ' ' + (ly - 4) + 'v8M' + (act.x + act.w) + ' ' + (ly - 4) + 'v8M' + act.x + ' ' + ly + 'H' + (act.x + act.w));
          gLine.setAttribute('stroke', gc);
          // SP-AERMEL: Feld und Maßlinie parallel zur Ärmelnaht drehen
          if (act.rot) {
            gArea.setAttribute('transform', 'rotate(' + act.rot + ' ' + act.pivot.x + ' ' + act.pivot.y + ')');
            gLine.setAttribute('transform', 'rotate(' + act.rot + ' ' + lcx + ' ' + lcy + ')');
          } else { gArea.removeAttribute('transform'); gLine.removeAttribute('transform'); }
        }
        tag.textContent = fmt(act.cm.w) + ' cm' + (num(act.lg.width) > 0 ? '' : ' · Vorschlag');
        var tx = lcx, ty = above ? ly - 30 : ly + 6;
        if (act.rot) {
          var rr = act.rot * Math.PI / 180, ddy = ly - lcy;
          tx = lcx - ddy * Math.sin(rr); ty = lcy + ddy * Math.cos(rr) - 30;
        }
        tag.style.left = tx + 'px';
        tag.style.top = ty + 'px';
        // Etikett bleibt in der Detailansicht normal groß und waagerecht
        tag.style.transformOrigin = '50% 100%';
        tag.style.transform = S.zf > 1 ? 'translateX(-50%) scale(' + (1 / S.zf) + ')' : '';
      }

      // Hinweise
      var parts = [];
      // SP-POS-INFO (10.10.2026): Druckfläche und „Logo ziehen zum Verschieben“ stehen jetzt im „i“ an jeder Positions-Taste
      if (ghost && ghost.P.collar) parts.push('Gestrichelt: Druckfläche am Kragen (' + fmt(ghost.P.area[0]) + ' × ' + fmt(ghost.P.area[1]) + ' cm). Noch kein Logo am Kragen – wähle bei einem Logo die Position „Kragen links“ oder „Kragen rechts“.');
      else if (ghost) parts.push('Gestrichelt: Druckfläche am Ärmel (' + fmt(ghost.P.area[0]) + ' × ' + fmt(ghost.P.area[1]) + ' cm). Noch kein Logo am Ärmel – wähle bei einem Logo die Position „Ärmel links“ oder „Ärmel rechts“.');
      else if (!L.items.length) parts.push(side === 'back' ? 'Hinten ist noch kein Logo platziert.' : 'Vorne ist noch kein Logo platziert.');
      hintTxt.textContent = parts.join(' ');
      hintTxt.hidden = !parts.length;
      var off = act && act.lg._splp && (act.lg._splp.dx || act.lg._splp.dy);
      resetBtn.hidden = !off;
      var w = [];
      L.items.forEach(function (it) {
        if (it.cm.w > it.P.area[0] + 0.01 || it.cm.h > it.P.area[1] + 0.01) {
          w.push('Logo ' + (it.i + 1) + ' ist größer als die Druckfläche für ' + it.P.label + ' (max. ' + fmt(it.P.area[0]) + ' × ' + fmt(it.P.area[1]) + ' cm).');
        }
      });
      if (L.items.some(function (it) { return (it.P.hat || it.P.cap) ? it.low : L.g.conf === 'low'; })) w.push('Vorschau ungefähr – die genaue Platzierung zeigen wir dir mit der Druckfreigabe.');
      if (side === 'back' && S.backSymbol) w.push('Für diese Farbe gibt es kein Foto der Rückseite – die Vorschau nutzt das Vorderfoto.');
      warn.textContent = w.join(' ');
      warn.hidden = !w.length;
    }

    var colorsSig = '';
    function renderColors() {
      var on = cfg.colors !== false && st.sel.length >= 2;
      colorsBox.hidden = !on;
      if (!on) return;
      var sig = st.sel.join('|') + '#' + st.active;
      if (sig === colorsSig) return;
      colorsSig = sig;
      colorsRow.textContent = '';
      st.sel.forEach(function (name) {
        var c = colorMap[name] || {};
        var b = mk('button', 'splp-dot'); b.type = 'button';
        b.setAttribute('aria-label', name);
        b.title = name;
        b.setAttribute('aria-pressed', name === st.active ? 'true' : 'false');
        if (c.hex) b.style.backgroundColor = c.hex;
        else if (c.image) b.style.backgroundImage = 'url("' + c.image + '")';
        b.addEventListener('click', function () {
          var sw = el.querySelector('[data-spn-sw="' + (window.CSS && CSS.escape ? CSS.escape(name) : name) + '"]');
          if (sw) sw.click();
        });
        colorsRow.appendChild(b);
      });
    }

    function show(side, zoom) {
      S.mode = 'mock'; S.side = side; S.zoom = zoom || false;
      if (side === 'front' && S.front && fname(stageImg.currentSrc || stageImg.src) !== fname(S.front)) {
        stageImg.removeAttribute('srcset');
        stageImg.src = S.front;
      }
      // aktives Logo auf die gezeigte Seite legen
      var cur = st.logos[S.active];
      if (zoom && !isSleeve(cur, zoom)) {
        for (var z = 0; z < st.logos.length; z++) if (isSleeve(st.logos[z], zoom)) { S.active = z; cur = st.logos[z]; break; }
      }
      if (!cur || !PZ(cur.pos) || PZ(cur.pos).side !== side) {
        for (var i = 0; i < st.logos.length; i++) if (PZ(st.logos[i].pos) && PZ(st.logos[i].pos).side === side) { S.active = i; break; }
      }
      render();
    }

    /* ---------- Verschieben ---------- */
    var drag = null;
    function snap(v) { return Math.round(v * 2) / 2; }
    function startDrag(e) {
      if (S.mode !== 'mock' || (e.button != null && e.button !== 0)) return;
      var d = e.currentTarget, i = +d.dataset.i, lg = st.logos[i];
      if (!lg) return;
      e.preventDefault();
      S.active = i;
      var o = meta(lg);
      var P0 = PZ(lg.pos);
      drag = { el: d, i: i, x: e.clientX, y: e.clientY, dx: o.dx, dy: o.dy, ppc: ((S.kp && S.kp[i]) || S.ppc || 1) * (S.zf || 1), rot: P0 && (P0.sleeve || P0.collar || P0.cap) ? (o.rot || 0) : 0, moved: false };
      try { d.setPointerCapture(e.pointerId); } catch (err) {}
      d.classList.add('is-drag');
      d.addEventListener('pointermove', moveDrag);
      d.addEventListener('pointerup', endDrag);
      d.addEventListener('pointercancel', endDrag);
      render();
    }
    function moveDrag(e) {
      if (!drag) return;
      var lg = st.logos[drag.i];
      if (!lg) return;
      var o = meta(lg);
      var mx = (e.clientX - drag.x) / drag.ppc, my = (e.clientY - drag.y) / drag.ppc;
      if (drag.rot) { // SP-AERMEL: Bewegung ins gedrehte Feld umrechnen
        var r = -drag.rot * Math.PI / 180, t = mx * Math.cos(r) - my * Math.sin(r);
        my = mx * Math.sin(r) + my * Math.cos(r); mx = t;
      }
      o.dx = snap(drag.dx + mx);
      o.dy = snap(drag.dy + my);
      drag.moved = true;
      render();
    }
    function endDrag() {
      if (!drag) return;
      var d = drag.el;
      d.classList.remove('is-drag');
      d.removeEventListener('pointermove', moveDrag);
      d.removeEventListener('pointerup', endDrag);
      d.removeEventListener('pointercancel', endDrag);
      drag = null;
      render(); scheduleMinis();
    }
    function keyMove(e) {
      var k = { ArrowLeft: [-0.5, 0], ArrowRight: [0.5, 0], ArrowUp: [0, -0.5], ArrowDown: [0, 0.5] }[e.key];
      if (!k) return;
      e.preventDefault();
      var i = +e.currentTarget.dataset.i, lg = st.logos[i];
      if (!lg) return;
      var o = meta(lg);
      o.dx += k[0]; o.dy += k[1];
      S.active = i;
      render(); scheduleMinis();
    }

    /* ---------- Zeichnen auf Canvas (Mini + Warenkorb) ---------- */
    function drawSide(ctx, x0, y0, W, H, side) {
      var u = sideUrl(side);
      var files = st.logos.map(function (lg) { return getLogo(fileOf(lg)); });
      return Promise.all([getInfo(u, side), Promise.all(files)]).then(function (r) {
        var info = r[0];
        ctx.save();
        ctx.fillStyle = GROUND; ctx.fillRect(x0, y0, W, H);
        var L = layout(side, W, H, info);
        ctx.globalCompositeOperation = 'darken';
        ctx.drawImage(info.img, x0 + L.g.ox, y0 + L.g.oy, L.g.rw, L.g.rh);
        ctx.globalCompositeOperation = 'source-over';
        L.items.forEach(function (it) {
          var x = x0 + it.x, y = y0 + it.y;
          ctx.save();
          if (it.rot) { // SP-AERMEL
            ctx.translate(x + it.w / 2, y + it.h / 2); ctx.rotate(it.rot * Math.PI / 180);
            x = -it.w / 2; y = -it.h / 2;
          }
          if (it.logo && it.logo.canvas) {
            ctx.drawImage(it.logo.canvas, x, y, it.w, it.h);
          } else {
            ctx.fillStyle = 'rgba(230,248,242,.92)'; ctx.fillRect(x, y, it.w, it.h);
            ctx.strokeStyle = INK; ctx.lineWidth = Math.max(1, W / 400); ctx.setLineDash([4, 3]);
            ctx.strokeRect(x + 0.5, y + 0.5, it.w - 1, it.h - 1); ctx.setLineDash([]);
            if (it.w > 40) {
              ctx.fillStyle = INK; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
              ctx.font = '700 ' + Math.max(9, Math.round(W / 50)) + 'px ' + FONT;
              ctx.fillText('LOGO ' + (it.i + 1), x + it.w / 2, y + it.h / 2);
            }
          }
          ctx.restore();
        });
        ctx.restore();
      });
    }

    var miniTimer = null;
    function scheduleMinis() {
      if (!minis) return;
      clearTimeout(miniTimer);
      miniTimer = setTimeout(drawMinis, 180);
    }
    function drawMinis() {
      if (!minis || !S.front) return;
      [miniF, miniB].forEach(function (m) {
        if (S.cap && m.btn.hidden) return; // SP-CAP: ohne Rückfoto keine Mini-Rückseite
        var c = m.canvas, px = Math.round(Math.min(200, m.btn.clientWidth || 200) * (window.devicePixelRatio || 1));
        px = Math.max(160, Math.min(480, px));
        if (c.width !== px) { c.width = px; c.height = px; }
        drawSide(c.getContext('2d'), 0, 0, px, px, m.side).catch(function () {});
      });
    }

    function composePreview() {
      var sides = [];
      st.logos.forEach(function (lg) { var P = PZ(lg.pos); if (P && sides.indexOf(P.side) < 0) sides.push(P.side); });
      if (S.cap && S.backSymbol) sides = sides.filter(function (s) { return s !== 'back'; }); // SP-CAP: kein Rückfoto
      if (!sides.length) sides = ['front'];
      sides.sort(function (a, b) { return a === 'front' ? -1 : b === 'front' ? 1 : 0; });
      var S1 = 800, FOOT = 72, c = document.createElement('canvas');
      c.width = S1 * sides.length; c.height = S1 + FOOT;
      var ctx = c.getContext('2d');
      ctx.fillStyle = GROUND; ctx.fillRect(0, 0, c.width, c.height);
      var fontsReady = (document.fonts && document.fonts.load) ? Promise.all([
        document.fonts.load('700 20px "Trade Gothic Shirtplus"'), document.fonts.load('400 20px "Trade Gothic Shirtplus"')
      ]).catch(function () {}) : Promise.resolve();
      return fontsReady.then(function () {
        return Promise.all(sides.map(function (side, k) { return drawSide(ctx, k * S1, 0, S1, S1, side); }));
      }).then(function () {
        ctx.textBaseline = 'alphabetic';
        sides.forEach(function (side, k) {
          ctx.fillStyle = INK; ctx.textAlign = 'left';
          ctx.font = '700 20px ' + FONT;
          ctx.fillText(side === 'front' ? 'VORNE' : 'HINTEN', k * S1 + 24, 44);
        });
        ctx.fillStyle = '#E3E6E4'; ctx.fillRect(0, S1, c.width, 1);
        var bits = [(cfg.title || spnData.title || ''), st.active || ''];
        st.logos.forEach(function (lg, i) {
          var P = PZ(lg.pos) || POS.links, o = meta(lg), t = 'Logo ' + (i + 1) + ': ' + (lg.posLabel || P.label) + ', ' + fmt(sizeCm(lg).w) + ' cm';
          if (o.dx || o.dy) t += ', verschoben';
          bits.push(t);
        });
        ctx.textAlign = 'left'; ctx.fillStyle = MUTED; ctx.font = '400 20px ' + FONT;
        ctx.fillText(bits.filter(Boolean).join(' · '), 24, S1 + 44, c.width - 200);
        ctx.textAlign = 'right'; ctx.fillStyle = INK; ctx.font = '700 20px ' + FONT;
        ctx.fillText('SHIRTPLUS', c.width - 24, S1 + 44);
        return new Promise(function (res, rej) {
          try { c.toBlob(function (b) { b ? res(b) : rej(new Error('blob')); }, 'image/jpeg', 0.86); } catch (e) { rej(e); }
        });
      });
    }

    /* ---------- Haken für sp-pdp-neu.js ---------- */
    el.spnExtraProps = function () {
      var out = {};
      st.logos.forEach(function (lg, i) {
        var o = lg._splp;
        if (!o || o.nophoto || (!o.dx && !o.dy)) return; // SP-CAP: ohne Bildvorschau keine Verschiebung
        var p = [], Pa = PZ(lg.pos);
        if (Pa && Pa.collar) { // SP-KRAGEN: im Feld parallel zur Kragenkante
          if (o.dx) p.push(fmt(Math.abs(o.dx)) + ' cm entlang der Kragenkante');
          if (o.dy) p.push(fmt(Math.abs(o.dy)) + ' cm quer zur Kragenkante');
        } else if (Pa && Pa.sleeve) { // SP-AERMEL: im Feld parallel zur Ärmelnaht
          if (o.dx) p.push(fmt(Math.abs(o.dx)) + ' cm Richtung Ärmel' + (o.dx * Pa.sleeve > 0 ? 'rückseite' : 'vorderseite'));
          if (o.dy) p.push(fmt(Math.abs(o.dy)) + ' cm Richtung ' + (o.dy > 0 ? 'Saum' : 'Schulter'));
        } else {
          if (o.dx) p.push(fmt(Math.abs(o.dx)) + ' cm nach ' + (o.dx > 0 ? 'rechts' : 'links'));
          if (o.dy) p.push(fmt(Math.abs(o.dy)) + ' cm ' + (o.dy > 0 ? 'tiefer' : 'höher'));
        }
        out[(i + 1) + '. Logo Verschiebung'] = p.join(', ') + ' (wie in der Vorschau)';
      });
      return out;
    };
    el.spnPreviewFiles = function () {
      if (cfg.cart === false) return Promise.resolve([]);
      var name = 'vorschau-' + (cfg.handle || 'artikel').slice(0, 40) + '-' + String(st.active || 'farbe').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.jpg';
      var p = composePreview().then(function (blob) {
        var f;
        try { f = new File([blob], name, { type: 'image/jpeg' }); } catch (e) { f = blob; f.name = name; }
        return [{ key: 'Vorschau', file: f }];
      }).catch(function (e) { console.warn('[splp] Vorschaubild', e); return []; });
      return timeout(p, 6000, []);
    };

    /* ---------- Ereignisse ---------- */
    function onChange() {
      // SP-CAP: sp-pdp-neu.js erkennt Caps erst nach dem Aris-Optionssatz → Rückseite dann neu bestimmen
      if ((el.spnCap === true) !== !!S.cap) { S.cap = el.spnCap === true; updateUrls(); }
      if (st.active !== S.color) { S.color = st.active; S.mode = 'mock'; updateUrls(); }
      st.logos.forEach(function (lg, i) {
        var m = lg._splp, P = PZ(lg.pos);
        if (!m) {
          meta(lg);
          if (i > 0 && P) { S.active = i; S.side = P.side; S.mode = 'mock'; S.zoom = zoomKind(P); }
        } else if (m.pos !== lg.pos) {
          m.pos = lg.pos; m.dx = 0; m.dy = 0;
          if (P) { S.active = i; S.side = P.side; S.mode = 'mock'; S.zoom = zoomKind(P); }
        }
        var f = fileOf(lg);
        if (f && !logoDone.has(f)) getLogo(f).then(function () { render(); scheduleMinis(); });
      });
      if (S.active >= st.logos.length) S.active = 0;
      render(); scheduleMinis();
    }
    el.addEventListener('spn:change', onChange);

    /* SP-POS-INFO (10.10.2026): „i“ an jeder Positions-Taste in Schritt 3. Hover (Desktop) bzw. Tippen (Handy) zeigt
       die Druckfläche, die im Foto gestrichelt ist, und den Hinweis zum Verschieben. Ersetzt den Text unter dem Foto.
       Die Tasten baut sp-pdp-neu.js bei jeder Änderung neu – deshalb nach jedem 'spn:change' ergänzen. */
    var EN = /^en/i.test(document.documentElement.lang || '');
    function trEn(t) { return (EN && window.spI18nEn && window.spI18nEn.tr) ? window.spI18nEn.tr(t) : t; }
    function posKeys() {
      var m = {};
      Object.keys(POS).forEach(function (k) { m[POS[k].label] = k; });
      (el.spnAris || []).forEach(function (a) { a.pos.forEach(function (q) { m[q.label] = q.key; }); });
      Object.keys(m).forEach(function (l) { var e = trEn(l); if (e !== l) m[e] = m[l]; });
      return m;
    }
    function tipFor(k) {
      var P = PZ(k), ar = (P && P.area) || arisArea(k), drawn = !!(P && cfg.area !== false && (!P.sleeve || SLEEVES));
      if (P && P.cap && P.side === 'back' && S.cap && S.backSymbol) drawn = false; // SP-CAP: Hinten ohne Rückfoto
      if (!ar) return '';
      var a = String(ar[0]).replace('.', ',') + ' × ' + String(ar[1]).replace('.', ',') + ' cm';
      if (EN) return 'Print area up to ' + a + (drawn ? ' – shown dashed in the photo. Drag the logo in the photo to move it.' : '.');
      return 'Druckfläche bis ' + a + (drawn ? ' – im Foto gestrichelt. Logo im Foto ziehen zum Verschieben.' : '.');
    }
    function placeTip(i) {
      var tip = i.querySelector('.splp-i__tip');
      tip.style.setProperty('--dx', '0px');
      var r = tip.getBoundingClientRect(), vw = document.documentElement.clientWidth, dx = 0;
      if (r.right > vw - 12) dx = vw - 12 - r.right;
      if (r.left + dx < 12) dx = 12 - r.left;
      tip.style.setProperty('--dx', Math.round(dx) + 'px');
    }
    function openTip(i, on) {
      if (on) { Array.prototype.forEach.call(el.querySelectorAll('.splp-i.is-open'), function (o) { if (o !== i) o.classList.remove('is-open'); }); }
      i.classList.toggle('is-open', on);
      if (on) placeTip(i);
    }
    function decoratePills() {
      if (!logosCards) return;
      var keys = null;
      Array.prototype.forEach.call(logosCards.querySelectorAll('.spn-pill'), function (b) {
        if (b.querySelector('.splp-i')) return;
        var label = (b.firstChild && b.firstChild.nodeType === 3 ? b.firstChild.nodeValue : b.textContent).trim();
        keys = keys || posKeys();
        var k = keys[label], t = k ? tipFor(k) : '';
        if (!t) return;
        var i = mk('span', 'splp-i'); i.setAttribute('aria-hidden', 'true');
        i.appendChild(mk('span', 'splp-i__ic', 'i'));
        i.appendChild(mk('span', 'splp-i__tip', t));
        b.appendChild(i); b.classList.add('has-i');
        b.setAttribute('aria-description', (b.getAttribute('aria-description') ? b.getAttribute('aria-description') + '. ' : '') + t);
        i.addEventListener('mouseenter', function () { openTip(i, true); });
        i.addEventListener('mouseleave', function () { openTip(i, false); });
        i.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openTip(i, !i.classList.contains('is-open')); });
      });
    }
    el.addEventListener('spn:change', decoratePills);
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.splp-i')) Array.prototype.forEach.call(el.querySelectorAll('.splp-i.is-open'), function (o) { o.classList.remove('is-open'); });
    });
    decoratePills();

    // Klick/Fokus in einer Logo-Karte: dieses Logo aktiv, Foto auf seine Seite
    if (logosCards) {
      var pick = function (e) {
        var card = e.target.closest && e.target.closest('.spn-logo');
        if (!card) return;
        var cards = Array.prototype.slice.call(logosCards.querySelectorAll('.spn-logo'));
        var i = cards.indexOf(card), lg = st.logos[i];
        if (i < 0 || !lg || !PZ(lg.pos)) return;
        var zz = zoomKind(PZ(lg.pos));
        if (S.active !== i || S.side !== PZ(lg.pos).side || S.zoom !== zz) { S.active = i; S.side = PZ(lg.pos).side; S.zoom = zz; S.mode = 'mock'; render(); }
      };
      logosCards.addEventListener('pointerdown', pick, true);
      logosCards.addEventListener('focusin', pick, true);
    }
    // Galerie-Bild angeklickt → freies Foto, Vorschau ausblenden
    Array.prototype.forEach.call(el.querySelectorAll('[data-spn-thumb]'), function (t) {
      t.addEventListener('click', function () { S.mode = 'photo'; render(); });
    });
    stageImg.addEventListener('load', function () { render(); });
    backImg.addEventListener('load', function () { render(); });
    if (window.ResizeObserver) new ResizeObserver(function () { render(); }).observe(stage);
    else window.addEventListener('resize', render);

    updateUrls();
    onChange();
  }

  function boot() {
    var cfg = {};
    var node = document.querySelector('[data-splp-data]');
    if (!node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    var tries = 0;
    (function wait() {
      var roots = document.querySelectorAll('[data-spn-root]');
      var pending = false;
      Array.prototype.forEach.call(roots, function (el) {
        if (el.spnState) init(el, cfg); else pending = true;
      });
      if (pending && tries++ < 50) setTimeout(wait, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
